import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions } from '_api/types';

export const GET_PATIENT_SEX = 'get-patient-sex';

export const useGetPatientSex = () =>
  useGetQuery<ConstantsNameDescriptions<string>[]>(
    () => `/constant/sex`,
    {},
    [GET_PATIENT_SEX],
    {
      refetchOnWindowFocus: false,
    },
  );
